<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="550px"
    :before-close="handleClose"
  >
     <coententTable
              :columns="columns"
              :dataSource="dataSource"
              :loading="loading"
              :customSlot="customSlot"
              :y="500"
            >
            <template v-slot:time="scopeVal">
                 <div v-if="scopeVal.scope.status == 0">{{scopeVal.scope.time}}</div>
                <div style="color:rgba(245, 108, 108, 1)"v-if="scopeVal.scope.status == 1">{{scopeVal.scope.time}}</div>
            </template>
            <template v-slot:ms="scopeVal">
                <div v-if="scopeVal.scope.status == 0">{{scopeVal.scope.ms}}</div>
                <div style="color:rgba(245, 108, 108, 1)"v-if="scopeVal.scope.status == 1">{{scopeVal.scope.ms}}</div>
            </template>
            <template v-slot:status="scopeVal">
                <div v-if="scopeVal.scope.status == 0">合格</div>
                <div style="color:rgba(245, 108, 108, 1)"v-if="scopeVal.scope.status == 1">不合格</div>
            </template>
            </coententTable>
  </el-dialog>
</template>
<script >
import coententTable from "@/components/coentent_table.vue";
import {siteUsabilityInfoList} from '../index';
export default {
  components:{
    coententTable
  },
  data() {
    return {
       columns: [
        {
          title: "次数",
          dataIndex: "num",
          ellipsis: true,
        },
        {
          title: "监测时间",
          dataIndex: "time",
          ellipsis: true,
          width:120,
          scopedSlots: { customRender: "time" },
        },
        {
          title: "打开速度",
          dataIndex: "ms",
          ellipsis: true,
           width:120,
          scopedSlots: { customRender: "ms" },
        },
        {
          title: "监测结果",
          dataIndex: "status",
           width:120,
          scopedSlots: { customRender: "status" },
          ellipsis: true,
        }
      ],
      customSlot: [
        {
          name: "status",
          customRender: "status",
        },
        {
          name: "time",
          customRender: "time",
        },
        {
          name: "ms",
          customRender: "ms",
        },
         {
          name: "cishu",
          customRender: "cishu",
        }
      ],
       dataSource: [],
      loading: false,
      dialogTitle:'',
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    itemData:{}
  },
  mounted() {
    this.getList()
    this.dialogTitle = `站点可用性监测清单（${this.itemData.time}）`
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    getList(){
      this.loading = true;
      siteUsabilityInfoList({
        siteId:sessionStorage.getItem('siteId'),
        time: this.itemData.time,
      }).then((res)=>{
          if(res.code == 0){
              this.dataSource = res.data;
              for (let index = 0; index <  this.dataSource.length; index++) {
                const element =  this.dataSource[index];
                element.num = index + 1;
              }
          }
          this.loading = false;
      })
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog{
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}
/deep/ .el-dialog__title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
/deep/ .el-icon-close {
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
}
/deep/ .table{
  margin: 0px;
}
/deep/ .el-dialog__body{
  padding-top: 10px;
}

</style>
